<div style="padding: 0 25px" class="header header-fixed d-flex align-items-stretch justify-content-between">

    <!--begin::Header Menu Wrapper-->
    <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
        <!--begin::Header Logo-->
        <div class="header-logo">
          <a routerLink="/">
            <img alt="Logo" src="./assets/media/logos/logo_inside.png" loading="lazy" decoding="async">
          </a>
        </div>

    </div>

</div>

<div class="privacy-page">
  <div class="card card-custom gutter-b">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label">Policy & Privacy</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="category d-flex">
        <div class="categoty-details">
          <h4 class="font-color-primary-light">1. APPLICATION OF SAAS TERMS</h4>
          <p>1.1. By creating an account and clicking (I agree) you are bound to the terms mentioned herein.
          </p>
          <p>1.2. If your access and usage are on behalf of another person (e.g. a company), you confirm that
            you
            are
            authorized to, and do in fact, agree to these terms on that person’s behalf and that, by
            agreeing to
            these terms on that person’s behalf, that person is bound by these terms.</p>
          <p>1.3. If you do not agree to any of the terms mentioned herein, please immediately refrain from
            using
            our
            services. </p>
        </div>
        <div class="category-image">
          <img src="assets/media/logos/privacy.png" loading="lazy" decoding="async" alt="">
        </div>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">2. SOLUTIONS LICENSE</h4>
        <p>2.1. SANTECHTURE hereby grants to User a temporary, non-exclusive, and non-transferable license in
          the
          United Arab Emirates only (the "License") for User to use the software described hereunder (the
          "Software" and together with the support and Documentation to be provided therewith, the
          "Solution"),
          subject to the terms and conditions hereinafter set forth in this Terms of Use.</p>
        <p>2.2. User acknowledges that SANTECHTURE will not be delivering copies of the Software to User as part
          of
          the SaaS Services.</p>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">3. FEES AND PAYMENT TERMS</h4>
        <p>3.1. All subscription fees will be paid upfront and prior to the activation of the subscription.
        <p>3.2. If you wish to renew your subscription, then you must renew before the end of the subscription
          period to avoid any interruption or suspension of the services.</p>
        <p>3.3. SANTECHTURE may change its fees at any time, however the changes in the fees will be applied on
          the
          next cycle of subscription.</p>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">4. USE OF THE SOLUTION</h4>
        <p>4.1. User will only use the Solution at the approved locations and only for the purposes agreed upon.
        <p>4.2. The User must not amend or modify the Solution. </p>
        <p>4.3. User must prevent access to the Solution by any Person except User’s employees who need to have
          access thereto for the Permitted Use, and who are otherwise expressly bound by confidentiality
          obligations in respect of the Solution, by way of a confidentiality agreement or other written
          agreement. User shall not reproduce, adapt, translate, arrange, provide access to, or make available
          to
          any third party, either directly or indirectly, any part of the Solution (including any electronic
          materials necessary for its operation) except as permitted herein.</p>

      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">5. RESTRICTIONS </h4>
        <p>User shall not permit anyone to: (i) copy or republish the SaaS services or software, (ii) make the
          SAAS
          services available to any person other than authorized identity cube users, (iii) use or access the
          SaaS
          services to provide service bureau, time-sharing or other computer hosting services to third
          parties,
          (iv) modify or create derivative works based upon the SaaS services or documentation, (v) remove,
          modify
          or obscure any copyright, trademark or other proprietary notices contained in the software used to
          provide the SaaS services or in the documentation, (vi) reverse engineer, decompile, disassemble, or
          otherwise attempt to derive the source code of the software used to provide the SaaS services,
          except
          and only to the extent such activity is expressly permitted by applicable law, or (vii) access the
          SaaS
          services or use the documentation in order to build a similar product or competitive product.
          subject to
          the limited licenses granted herein, SANTECHTURE shall own all right, title and interest in and to
          the
          software, services, documentation, and other deliverables provided under this SaaS agreement,
          including
          all modifications, improvements, upgrades, derivative works and feedback related thereto and
          intellectual property rights therein. User agrees to assign all right, title and interest it may
          have in
          the foregoing to SANTECHTURE</p>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">6. COLLECTION AND USE OF DATA </h4>
        <p>SANTECHTURE may collect information about the User’s user activity (the “Data”). SANTECHTURE reserves
          the
          right to be able to utilize this Data, which may include information about the performance and usage
          statistics, to analyze trends, maintain the integrity of the system and continue to enhance the
          Solution. SANTECHTURE agrees not to disclose, other than under compulsion of law, any personal or
          business information that can be linked specifically to any user of the User. SANTECHTURE shall
          ensure
          that the Data is secured and backed-up regularly as per the industry standard. </p>

      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">7. User Obligations</h4>
        <p>7.1. User shall comply with all applicable local, state, national and foreign laws in connection with
          its
          use of the SaaS Services, including those laws related to data privacy, international
          communications,
          and the transmission of technical or personal data. User acknowledges that SANTECHTURE exercises no
          control over the content of the information transmitted by User or the Identity Cube users through
          the
          SaaS Services. User shall not upload, post, reproduce or distribute any information, software or
          other
          material protected by copyright, privacy rights, or any other intellectual property right without
          first
          obtaining the permission of the owner of such rights.</p>
        <p>7.2. User understands and agrees to use the Services solely for the purposes identified in this SaaS
          Agreement and only for proper business purposes in accordance with and as contemplated by this SaaS
          Agreement and applicable legislation including, without limitation, laws and regulations respecting
          data
          privacy, international communications, and the exporting and importing of data. </p>
        <p>7.3. User shall: (a) notify SANTECHTURE immediately of any unauthorized use of any password or user
          id or
          any other known or suspected breach of security, (b) report to SANTECHTURE immediately and use
          reasonable efforts to stop any unauthorized use of the SaaS Services that is known or suspected by
          User
          or any Identity user, and (c) not provide false identity information to gain access to or use the
          SaaS
          Services. </p>
        <p>7.4. User shall be solely responsible for the acts and omissions of its Administrator Users.
          SANTECHTURE
          shall not be liable for any loss of data or functionality caused directly or indirectly by the
          Administrator Users.</p>
        <p>7.5. User is solely responsible for collecting, inputting and updating all User Content stored on the
          Host, and for ensuring that the User Content does not (i) include anything that actually or
          potentially
          infringes or misappropriates the copyright, trade secret, trademark or other intellectual property
          right
          of any third party, or (ii) contain anything that is obscene, defamatory, harassing, offensive or
          malicious. User shall: (i) notify SANTECHTURE immediately of any unauthorized use of any password or
          user id or any other known or suspected breach of security, (ii) report to SANTECHTURE immediately
          and
          use reasonable efforts to stop any unauthorized use of the Service that is known or suspected by
          User or
          any user, and (iii) not provide false identity information to gain access to or use the Service.
        </p>
        <p>7.6. Subject to the SaaS terms of use, User shall grant to SANTECHTURE a limited, non-exclusive and
          non-transferable license, to copy, store, configure, perform, display and transmit User Content
          solely
          as necessary to provide the SaaS Services to User.</p>
        <p>7.7. SANTECHTURE shall have the absolute ownership and right to use and incorporate into the SaaS
          Services any suggestions, enhancement requests, recommendation or other feedback provided by User,
          including Users, relating to the operation of the SaaS Services.</p>

      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">8. SANTECHTURE' Warranties</h4>
        <p>8.1. SANTECHTURE represents and warrants that it will provide the SaaS Services in a professional
          manner
          consistent with general industry standards and that the SaaS Services will perform substantially in
          accordance with this agreement</p>
        <p>8.2. SANTECHTURE WARRANTS THAT THE SAAS SERVICES WILL PERFORM IN ALL MATERIAL RESPECTS IN ACCORDANCE
          WITH
          THIS AGREEMENT. SANTECHTURE DOES NOT GUARANTEE THAT THE SAAS SERVICES WILL BE PERFORMED ERROR-FREE
          OR
          UNINTERRUPTED, OR THAT SANTECHTURE WILL CORRECT ALL SAAS SERVICES ERRORS. USER ACKNOWLEDGES THAT
          SANTECHTURE DOES NOT CONTROL THE TRANSFER OF DATA OVER COMMUNICATIONS FACILITIES, INCLUDING THE
          INTERNET, AND THAT THE SAAS SERVICE MAY BE SUBJECT TO LIMITATIONS, DELAYS, AND OTHER PROBLEMS
          INHERENT
          IN THE USE OF SUCH COMMUNICATIONS FACILITIES.THIS SECTION SETS FORTH THE SOLE AND EXCLUSIVE WARRANTY
          GIVEN BY SANTECHTURE (EXPRESS OR IMPLIED) WITH RESPECT TO THE SUBJECT MATTER OF THIS AGREEMENT.
          NEITHER
          SANTECHTURE NOR ANY OF ITS SANTECHTURES OR OTHER SUPPLIERS WARRANT OR GUARANTEE THAT THE OPERATION
          OF
          THE SUBSCRIPTION SERVICE WILL BE UNINTERRUPTED, VIRUS-FREE OR ERROR-FREE, NOR SHALL SANTECHTURE OR
          ANY
          OF ITS SERVICE PROVIDERS BE LIABLE FOR UNAUTHORIZED ALTERATION, THEFT OR DESTRUCTION OF USER’S OR
          ANY
          USER’S DATA, FILES, OR PROGRAMS.</p>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">9. OWNERSHIP</h4>
        <p>SANTECHTURE OWNS OR OPERATE BY VALID LICENSE THE SOLUTION (INCLUDING ALL UNDERLYING ELEMENTS, CODES,
          DATABASES, AND INFORMATION WHICH ARE THE EXCLUSIVE PROPERTY OF SANTECHTURE DIRECTLY OR VIA LICENSE
          FROM
          A THIRD PARTY), AND THEREFORE NO PART OF THE SOLUTION MAY NOT BE ADOPTED, COPIED, MODIFIED, OR USED
          OR
          RELIED UPON IN ANY WAY UNLESS AS EXPLICITLY PERMITTED PURSUANT TO THE TERMS OF THIS AGREEMENT.
          SANTECHTURE HAS THE RIGHT TO GRANT TO USER THE LICENSE WITHOUT VIOLATING ANY RIGHT OF ANY THIRD
          PARTY,
          AND THERE IS CURRENTLY NO ACTUAL OR THREATENED SUIT BY ANY SUCH THIRD PARTY BASED ON AN ALLEGED
          VIOLATION OF SUCH RIGHT BY SANTECHTURE.</p>
        <div class="subCategories ml-5">
          <h5>9.1. CONFIDENTIALITY </h5>
          <div class="subcategory__">
            <h5>9.2. Confidential Information</h5>

            <p>A. The User agrees that both during and after for five (5) years post the expiry or
              termination of this Agreement) the period of the User’s engagement with SANTECHTURE, the
              User shall hold in confidence all Confidential Information (which shall mean all information
              (including all documents and other tangible items which record information including in
              electronic or other storage form in computer readable format or otherwise), computer code,
              computer and healthcare records, specifications, or formulas which are either protected as a
              trade secret or is notified by SANTECHTURE to be of a confidential nature) and not reveal
              any Confidential Information to any person or entity without the prior written approval of
              SANTECHTURE and shall not, without the prior written approval of SANTECHTURE, directly or
              indirectly: (i) reveal, report, publish, disclose or transfer any Confidential Information
              to any person or entity; or (ii) use any Confidential Information for any purpose or for the
              benefit of any person or entity, except as may be necessary only to use the Solution under
              the terms of this Agreement.</p>
            <p>B. All Confidential Information in a written or tangible form shall be the property of
              SANTECHTURE, kept secret and diligently protection against loss or unauthorized use or
              reproduction, and shall be delivered to SANTECHTURE at any time upon request. If requested
              by SANTECHTURE, or immediately upon termination from SANTECHTURE, the User shall return to
              SANTECHTURE all Confidential Information, including all copies (including backup copies)
              whether written, electronic or otherwise, in the possession of, or under the control of, the
              User unless it is required by law that the User shall keep a copy of such information.</p>
            <p><b>Customer Data.</b> Customer Data shall mean all personal data relating to a policyholder
              and its dependents, or, if the policyholder is a company, shall mean such company’s
              employees and dependents that is collected by either Party (or an owner of subsidiary of
              either Party) as a result of entering into this Agreement. The Parties acknowledge and agree
              that The User owns all rights in the Customer Data. SANTECHTURE shall use the Customer Data
              only for the purpose of performing its obligations under this Agreement. For the avoidance
              of doubt, other than the User, SANTECHTURE must not use Customer Data any purpose other than
              performing its’ obligations under this agreement. Such obligations must not continue
              following the date of termination or expiry of this Encounter</p>
            <p>C. The User acknowledges that nothing herein is intended to give the User any ownership
              interest in any of the Confidential Information.</p>
          </div>
          <div class="subcategory__">
            <h5>9.3. Exemptions</h5>
            <p>The foregoing provisions of this Section shall not apply to:</p>
            <p>A. Confidential Information which is or becomes generally available to the public other than
              as a result of a disclosure by either Party or a breach of this Agreement by either Party.
            </p>
            <p>B. Confidential Information which was available to User on a non-confidential basis prior to
              the date hereof from a person other than SANTECHTURE, any client or customer, provided,
              that: (i) such person was not otherwise bound by confidentiality obligations to SANTECHTURE
              or any client or customer; and (ii) such person was not otherwise prohibited from disclosing
              the Confidential Information to User.</p>
            <p>C. Confidential Information which the User is required by law to disclose, in which case,
              User will provide SANTECHTURE with notice of such obligation immediately to allow
              SANTECHTURE to seek such intervention as it may deem appropriate to prevent such disclosure
              including and not limited to initiating legal or administrative proceedings prior to
              disclosure.</p>
          </div>
        </div>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">10. AUDITS</h4>
        <p>SANTECHTURE may, from time to time, conduct audits to determine User's compliance with this
          Agreement. Customer will cooperate in all such audits. SANTECHTURE may conduct audits at User’s
          facilities during normal business hours upon reasonable notice to the User. All information gathered
          in such audits shall be deemed confidential and will not be disclosed by SANTECHTURE to any third
          party. All costs of the audit shall be borne by SANTECHTURE unless an audit reveals a material
          breach of the Agreement; in that event, in addition to any other damages to which SANTECHTURE may be
          entitled to collect from User, User shall be liable to SANTECHTURE for the cost of the audit. </p>
      </div>
      <div class="categoty">
        <h4 class="font-color-primary-light">11. Remedies</h4>
        <p>User acknowledges that money damages would be both incalculable and an insufficient remedy for any
          breach of these terms and conditions and that any such breach would cause SANTECHTURE irreparable
          harm. Accordingly, User also agrees that in such event, the User, in addition to any other remedies
          at law or in equity it may have, is entitled, without the requirement of posting any security, to
          equitable relief, including injunctive relief and specific performance.</p>
      </div>

      <div class="categoty">
        <h4 class="font-color-primary-light">12. DISCLAIMER OF WARRANTIES</h4>
        <p>The services and information provided by SANTECHTURE are provided "as is" without any warranties of
          any kind including warranties of availability, fitness for a particular purpose, or non-infringement
          of intellectual property</p>
      </div>


      <div class="categoty">
        <h4 class="font-color-primary-light">13. GOVERNING LAW AND DISPUTE RESOLUTION</h4>
        <p>13.1. This Agreement shall be governed by and construed under the laws of the Emirate of Dubai and
          the laws of the United Arab Emirates as applicable therein. </p>
        <p>13.2. Any dispute or claim arising out of or relating to this Agreement or breach thereof which shall
          be resolved amicably. </p>
        <p>13.3. If the Parties didn’t reach any amicable solution, then they may refer the dispute to the
          non-exclusive jurisdiction of Dubai Courts. SANTECHTURE reserves the right to file or refer dispute
          to any jurisdiction other than Dubai courts, or to the jurisdiction courts of the user’s domicile.
        </p>
      </div>

      <div class="categoty">
        <h4 class="font-color-primary-light">14. FORCE MAJEURE</h4>
        <p>Neither party shall be liable by reason of any failure or delay in the performance of its obligations
          hereunder for any cause beyond the reasonable control of such party, including but not limited to
          electrical outages, failure of Internet service providers, riots, insurrection, war (or similar),
          fires, flood, earthquakes, explosions, and other acts of God.</p>
      </div>

      <div class="categoty">
        <h4 class="font-color-primary-light">15. TERMINATION</h4>
        <p>15.1. The User may terminate the services by unsubscribing Thirty (30) days before the next
          subscription period</p>
        <p>15.2. The User will have access to the Software until the last day of the subscription period which
          has been paid for, SANTECHTURE will not issue any refunds for cancelling the subscription at any
          time </p>
      </div>


      <div class="categoty">
        <h4 class="font-color-primary-light">16. Intellectual Property Rights:</h4>
        <p>16.1. The User agrees that all Intellectual Property Rights and every other right, title and interest
          in and to all information and materials (including images and data…etc) provided by the SANTECHTURE
          and its’ personnel, agents or representatives shall remain the sole property of SANTECHTURE at all
          times.</p>
        <p>16.2. Any Intellectual Property Rights created, developed or written by the SANTECHTURE in connection
          with to any license or Service provided to the User must belong exclusively to the SANTECHTURE and
          shall vest in it unconditionally and immediately.</p>
        <p>16.3. The presumption governing the Agreement shall be that SANTECHTURE shall be the sole owner of
          any Intellectual Property Right in any form contained in the solution, content, any service provided
          by the SANTECHTURE. </p>
        <p>16.4. For the avoidance of doubt, the User irrevocably and unconditionally agrees that all
          Intellectual Property Rights, titles and interests related the subject of this Agreement shall
          belong absolutely, unconditionally and exclusively to SANTECHTURE and shall vest in the SANTECHTURE
          immediately upon the same being created, developed, compiled, collated, configured, uploaded and/or
          written and the User shall have no claims or rights whatsoever over any of them. </p>
        <p>16.5. This term shall remain in full force and effect notwithstanding any termination of
          Subscriptions</p>
      </div>


      <div class="categoty">
        <h4 class="font-color-primary-light">17. Change in Terms</h4>
        <p>SANTECHTURE may change these Terms at any time by notifying you of the change by email or by posting
          a notice on the Website. Unless stated otherwise, any change takes effect from the date set out in
          the notice. You are responsible for ensuring you are familiar with the latest Terms. By continuing
          to access and use the Service from the date on which the Terms are changed, you agree to be bound by
          the changed Terms</p>
      </div>

      <div class="categoty">
        <h4 class="font-color-primary-light">18. END USER LICENSE TERMS </h4>
        <p>18.1. Any third party that has access to or uses the Solution from the User (hereinafter, the <b>“End
          User”</b>) shall not disclose, permit to be disclosed, or otherwise resell or transfer, with or
          without consideration, all or any portion of the Solution or any data output from the Solution to
          any third party.</p>
        <p>18.2. End User shall maintain the confidentiality of the Solution.</p>
        <p>18.3. End User may disclose the Solution only to the extent required by law, and in such case only
          after prompt written notice to SANTECHTURE allowing it the opportunity to interpose all objections
          to the proposed disclosure.</p>
        <p>18.4. End User shall not use the Solution for any purpose outside the scope of this Agreement.</p>
        <p>18.5. End User shall not reverse engineer, disassemble or decompile the Solution.</p>
        <p>18.6. End User shall not duplicate the Solution.</p>
        <p>18.7. At the termination of this Subscription, End User shall discontinue use of the Solution and
          destroy or return to SANTECHTURE the Solution and all copies thereof.</p>
        <p>18.8. SANTECHTURE disclaims all warranties of any kind relating to the Solution, other than that the
          Solution will perform in accordance with the end user documentation for them.</p>
        <p>18.9. SANTECHTURE shall not be liable to any End User for any indirect, incidental, consequential,
          special, punitive or exemplary damages. SANTECHTURE’ liability to any End User for direct damages
          relating to the Solution shall be limited to the amount End User has paid to SANTECHTURE for use of
          the Solution in the year in which the cause of action arose.</p>
        <p>18.10. SANTECHTURE shall be expressly entitled to enforce its rights pursuant to the provisions of
          this Agreement as they relate to Solution, regardless of any alleged or actual breach or default
          hereunder by SANTECHTURE, or any expiration or termination of this Agreement.</p>
      </div>


    </div>
  </div>
</div>
